import ContentLoader from 'react-content-loader';

const HybridJobOutputLoader = () => (
  <ContentLoader
    backgroundColor="rgba(0,96,250, 0.1)"
    foregroundColor="rgba(204,116,245, 0.3)"
    viewBox="0 0 380 50"
  >
    <rect x="0" y="0" rx="3" ry="3" width="100%" height="50" />
  </ContentLoader>
);

export default HybridJobOutputLoader;
